/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Richtextlinkplaceholder3Inputs */

const en_richtextlinkplaceholder3 = /** @type {(inputs: Richtextlinkplaceholder3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`pulsify.at/tickets`)
};

const de_richtextlinkplaceholder3 = /** @type {(inputs: Richtextlinkplaceholder3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`pulsify.at/tickets`)
};

/**
* | output |
* | --- |
* | "pulsify.at/tickets" |
*
* @param {Richtextlinkplaceholder3Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const richtextlinkplaceholder3 = /** @type {((inputs?: Richtextlinkplaceholder3Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Richtextlinkplaceholder3Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_richtextlinkplaceholder3(inputs)
	return de_richtextlinkplaceholder3(inputs)
});
export { richtextlinkplaceholder3 as "richTextLinkPlaceholder" }